"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _EmailCaptureCss = _interopRequireDefault(require("./EmailCapture.css.js"));

var _FormSubmit = _interopRequireDefault(require("./FormSubmit"));

var _LegalTerms = _interopRequireDefault(require("./LegalTerms"));

var _EmailInput = _interopRequireDefault(require("./EmailInput"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EmailCapture = function EmailCapture(_ref) {
  var setPage = _ref.setPage,
      email = _ref.email,
      setEmail = _ref.setEmail,
      theme = _ref.theme,
      setSubmission = _ref.setSubmission;

  var _useState = (0, _react.useState)(email === ''),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabledState = _useState2[1];

  var handleReadyChange = function handleReadyChange() {
    setDisabledState(false);
  };

  var handleSubmitClick = function handleSubmitClick(e) {
    e.preventDefault();
    setSubmission(true);
    setPage('offer');
    return;
  };

  var handleOptOutClick = function handleOptOutClick(e) {
    e.preventDefault();
    setSubmission(true);
    setEmail('');
    setPage('offer');
    return;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    key: "email-capture",
    style: _EmailCaptureCss.default.contentContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "email-form",
    style: _EmailCaptureCss.default.formCard
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "email-form-text",
    style: _EmailCaptureCss.default.formText
  }, "Would you like to receive relevant credit offers from", /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "The Card Note")), " and", /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, " Card Matcher ")), "directly to your inbox?"), /*#__PURE__*/_react.default.createElement("form", {
    style: _EmailCaptureCss.default.formEl
  }, /*#__PURE__*/_react.default.createElement(_EmailInput.default, {
    email: email,
    setEmail: setEmail,
    setEmailReady: handleReadyChange
  }), /*#__PURE__*/_react.default.createElement(_LegalTerms.default, {
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement(_FormSubmit.default, {
    disabledState: disabled,
    onSubmit: function onSubmit(e) {
      return handleSubmitClick(e);
    },
    onOptOut: function onOptOut(e) {
      return handleOptOutClick(e);
    },
    theme: theme
  }))));
};

var _default = (0, _radium.default)(EmailCapture);

exports.default = _default;

//# sourceMappingURL=EmailCapture.jsx.map